import Circular from "./Circular";
import ButtonLoader from "./button-loader";
import TypingIndicator from "./typingindicator";
export default { ButtonLoader, Circular, TypingIndicator };
